import axios from "axios";
//just a temporal solution
//to pass Authorization and x-eis-selected-location headers use some tools
// e.g. https://chrome.google.com/webstore/detail/modheader/idgpnmonknjnojddfkpgkljpfnnfcklj
// or just hardcode them in headers param for local usage
export class ApiService {
  constructor(baseURL) {
    this.requester = axios.create({
      baseURL,
      headers: {
        //The below 3 headers revent the caching of the response
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  }

  initErrorHandling = (callback) => {
    return this.requester.interceptors.response.use(undefined, () => {
      callback();
    });
  };

  get = (path) => {
    return this.requester.get(path);
  };

  delete = (path) => {
    return this.requester.delete(path);
  };

  post = (path, body) => {
    return this.requester.post(path, body);
  };
  put = (path, body) => {
    return this.requester.put(path, body);
  };
}

export default new ApiService();
